import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/styles/Login.css"; // reuse same styles
import builderImg from "../assets/img/builderimg.png"; // same left image
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function BuilderRegister() {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  // Password validation checks
  const validations = {
    length: password.length >= 8,
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    number: /\d/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  };

  return (
    <div className="builder-login-container">
      {/* Left Column (fixed, same as Login) */}
      <div className="left-col1 d-flex flex-column justify-content-center align-items-center text-center">
        <h1 className="builder-title mb-4" style={{ marginTop: "140px" }}>
          Register as Admin
        </h1>
        <img src={builderImg} alt="Builder" className="builder-img mt-4" />
      </div>

      {/* Right Column (scrollable form) */}
      <div className="right-col d-flex flex-column align-items-center">
        {/* Tabs */}
        <div className="tab-container">
          <div
            className="tab-inactive"
            onClick={() => navigate("/AdminLogin")}
            style={{ cursor: "pointer" }}
          >
            Login
          </div>
          <div className="tab-active">Register</div>
        </div>

        {/* Form (scrollable content) */}
        <div className="w-100 d-flex justify-content-center">
          <form
            className="register-form mt-4 px-2"
            style={{ maxHeight: "80vh", overflowY: "auto", width: "100%", maxWidth: "420px" }}
          >
            <div className="mb-3">
              <label className="form-label login-label-text">Full Name</label>
              <input
                type="text"
                className="form-control custom-input"
                placeholder="Alexander Mitchell"
              />
            </div>

            <div className="mb-3">
              <label className="form-label login-label-text">Email</label>
              <input
                type="email"
                className="form-control custom-input"
                placeholder=" Enter Your Email"
              />
            </div>

            <div className="mb-3">
              <label className="form-label login-label-text">Phone</label>
              <input
                type="text"
                className="form-control custom-input"
                placeholder="Enter Your Phone Number"
              />
            </div>

            <div className="mb-3">
              <label className="form-label login-label-text">PAN ID</label>
              <input
                type="text"
                className="form-control custom-input"
                placeholder="Enter Your Pan Id"
              />
            </div>

            <div className="mb-3">
              <label className="form-label login-label-text">REF ID</label>
              <input
                type="text"
                className="form-control custom-input"
                placeholder="Enter Your REF ID"
              />
            </div>

            {/* Password */}
            <div className="mb-3 position-relative">
              <label className="form-label login-label-text">Create password</label>
              <input
                type={showPassword ? "text" : "password"}
                className="form-control custom-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter Password"
              />
              <span
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            {/* Password Validation */}
           <div className="mb-2 d-flex flex-wrap gap-2">
  <span className={`validation-badge ${validations.length ? "active" : ""}`}>
    Minimum 8 characters
  </span>
  <span className={`validation-badge ${validations.upper ? "active" : ""}`}>
    Upper case
  </span>
  <span className={`validation-badge ${validations.lower ? "active" : ""}`}>
    Lower case
  </span>
  <span className={`validation-badge ${validations.special ? "active" : ""}`}>
    Special Character
  </span>
  <span className={`validation-badge ${validations.number ? "active" : ""}`}>
    Number
  </span>
</div>


            {/* Confirm Password */}
            <div className="mb-3 mt-3 position-relative">
              <label className="form-label login-label-text">Confirm password</label>
              <input
                type={showConfirmPassword ? "text" : "password"}
                className="form-control custom-input"
                placeholder="Confirm Password"
              />
              <span
                className="toggle-password"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            {/* Terms */}
            <div className="mb-3 d-flex align-items-center">
              <input
                type="checkbox"
                id="terms"
                style={{ width: "18px", height: "18px" }}
              />
              <label htmlFor="terms" className="ms-2">
                I agree to the{" "}
                <a href="/" className="text-primary">
                  Terms & Conditions
                </a>
              </label>
            </div>

            {/* Register Button */}
            <button type="submit" className=" login-btn w-100 mt-3" onClick={()=>{
                navigate('/Webadmindashboard')
            }}>
              Register
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
